import { app } from '../../../../app';
import { Controller } from './edit-administrator.controller';

app.component('editAdministrator', {
    bindings: {
        administrator: '<',
        administrators: '<',
        applications$: '<',
        appTypes$: '<',
        companyId: '<',
        groups$: '<',
    },
    controller: Controller,
    templateUrl: require('./edit-administrator.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/administrators/edit/edit-administrator.component.js